/*eslint-disable */
import Axios from "axios";
import cogoToast from "cogo-toast";
import { Field as Fieldmik, Form as Formiker, withFormik } from "formik";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Button, Dropdown, Form as FormUi, TextArea } from "semantic-ui-react";
import * as yup from "yup";
import { ERROR_MESSAGES } from "../../../config/const";
import { LOCAL_STORAGE } from "../../utils/constants";
import { AllRegex } from "../../../utils/validation";
import ReadAxios from "../../axiosComponent/read";
import UpdateAxios from "../../axiosComponent/update";
import MyCustomerType from "./myCustomertype";
import {
  errorAlertDispatcher, successAlertDispatcher
} from "../../../redux/actions/alertAction";

const InsertBranches = ({
  values,
  setFieldValue,
  t,
  touched,
  title,
  errors,
  handleSubmit,
  editData,
}) => {
  const [modalOpen, setmodalOpen] = useState(false);
  const [customertype, setcustomertype] = useState([]);
  const [industryName, setindustryName] = useState([]);
  const [isloading, setLoading] = useState(false);

  var vendorIndex = 0;

  useEffect(() => {
    getCustomerType();
    getIndustry();

  }, []);
  let handleOpen = () => setmodalOpen(true);

  let handleClose = () => {
    setmodalOpen(false);
  };

  const mappedBillingParty = (content, data) => {
    let temp = {}
    let arr = []

    if (data) {
      let paid = '0'
      let freeOfCost = '0'
      let toPay = '0'
      let toBeBilled = '0'

      data.value.map((object) => {
        if (object === 'paid') {
          paid = '1'
        } else if (object === 'freeOfCost') {
          freeOfCost = '1'
        } else if (object === 'toPay') {
          toPay = '1'
        } else if (object === 'toBeBilled') {
          toBeBilled = '1'
        }

      })
      if (data.value.length > 0) {
        content['paid'] = paid
        content['freeOfCost'] = freeOfCost
        content['toPay'] = toPay
        content['toBeBilled'] = toBeBilled

        UpdateAxios({
          completeURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party_type_mapping`, payload: content,
        }).then((response) => {
        })
      }
    }
  }

  const handleSubmited = () => {
    if (
      values.billingPartyName &&
      values.billingPartyAddress && values.billingPartyContactPersonNumber && values.billingPartyAddress && values.billingPartyPincodeNo) {
      handleSubmit();
      setmodalOpen(false);
    } else {
      handleSubmit();
    }
  };

  const getCustomerType = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_BASE_URL}/masters/billingPartyPaymentType`,
    })
      .then((res) => {
        setLoading(false);
        let ownership = res.data.resultSet;
        setcustomertype(
          ownership.map((item, index) => {
            return {
              key: index,
              value: item.billingPartyPaymentTypeId,
              text: item.billingPartyPaymentTypeName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const getIndustry = () => {
    setLoading(true);
    ReadAxios({
      completeURL: `${process.env.REACT_APP_BASE_URL}/masters/industry_segment`,
    })
      .then((res) => {
        setLoading(false);
        let industry = res.data.resultSet;
        setindustryName(
          industry.map((item, index) => {
            return {
              key: index,
              value: item.industrySegmentId,
              text: item.industrySegmentName,
              raw: { ...item },
            };
          }))
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <React.Fragment>
      <div className="ui form">
        <Formiker>
          <div className="container-fluid animated slideInDown pad w3-white">
            <div className="m-3 pl-3">
              <div className="ui form">
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Billing party Code"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    className="display-grid-center-imp"
                    width={4}
                    error={
                      touched.billingPartyCode && errors.billingPartyCode ? true : false
                    }
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyCode"
                      placeholder={"Code"}
                      value={values.billingPartyCode}
                    />
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Billing Part Name"} <span className='mandatory-star'> *</span>
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className="display-grid-center-imp"
                    error={
                      touched.billingPartyName && errors.billingPartyName ? true : false
                    }
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyName"
                      placeholder={"Name"}
                    />
                    {touched.billingPartyName && errors.billingPartyName ? (
                      <div className="error-msg">
                        {errors.billingPartyName}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group >
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Email Id"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    className="display-grid-center-imp"
                    width={4}
                    error={touched.billingPartyEmail && errors.billingPartyEmail ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyEmail"
                      placeholder={"Email Id"}
                    />
                    {touched.billingPartyEmail && errors.billingPartyEmail ? (
                      <div className="error-msg">
                        {errors.billingPartyEmail}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Mobile No."}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyContactPersonNumber"
                      placeholder={"Mobile No."}
                    />
                    {touched.billingPartyContactPersonNumber && errors.billingPartyContactPersonNumber ? (
                      <div>
                        {errors.billingPartyContactPersonNumber}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>

                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Address"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.billingPartyAddress && errors.billingPartyAddress ? true : false}
                  >
                    <Fieldmik
                      as={TextArea}
                      className="ui input"
                      name="billingPartyAddress"
                      placeholder={"Company Address"}
                    />
                    {touched.billingPartyAddress && errors.billingPartyAddress ? (
                      <div>
                        {errors.billingPartyAddress}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Pincode"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyPincodeNo"
                      placeholder={'Pincode'}
                    />
                    {touched.billingPartyPincodeNo && errors.billingPartyPincodeNo ? (
                      <div>
                        {errors.billingPartyPincodeNo}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      Customer Type
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.customer_type_id && errors.customer_type_id
                        ? true
                        : false
                    }
                  >
                    <Fieldmik
                      type="text"
                      multiple
                      name="customer_type_id"
                      placeholder="Select"
                      value={values.customer_type_id}
                      multiSelect={true}
                      editId={editData.billingPartyId}
                      mode={title}
                      component={MyCustomerType}
                      mappedBillingParty={mappedBillingParty}
                    />
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"industry"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={
                      touched.industrySegmentId && errors.industrySegmentId
                        ? true
                        : false
                    }
                  >
                    <Dropdown
                      clearable
                      style={{ width: "100%", fontWeight: "normal" }}
                      search
                      selection
                      name="industrySegmentId"
                      value={values.industrySegmentId}
                      placeholder={"Industry"}
                      onChange={(name, data) =>
                        setFieldValue(`industrySegmentId`, data.value)
                      }
                      options={industryName}
                    />
                    {touched.industrySegmentId && errors.industrySegmentId ? (
                      <div>
                        {errors.industrySegmentId}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Credit Period"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    error={touched.creditPeriod && errors.creditPeriod ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="creditPeriod"
                      placeholder={"Credit Period"}
                    />
                    {touched.creditPeriod && errors.creditPeriod ? (
                      <div>
                        {errors.creditPeriod}
                      </div>
                    ) : null}
                  </FormUi.Field>
                  <FormUi.Field width={2}></FormUi.Field>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"Contact Person"}<span className='mandatory-star'> *</span>
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className="display-grid-center-imp"
                    error={touched.billingPartyContactPerson && errors.billingPartyContactPerson ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="billingPartyContactPerson"
                      placeholder={"Contact Person"}
                    />
                    {touched.billingPartyContactPerson && errors.billingPartyContactPerson ? (
                      <div className="error-msg">
                        {errors.billingPartyContactPerson}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>

                <FormUi.Group inline>
                  <FormUi.Field width={2}>
                    <label className="labelName">
                      {"PAN Number"}
                    </label>
                  </FormUi.Field>
                  <FormUi.Field
                    width={4}
                    className="display-grid-center-imp"
                    error={touched.panNumber && errors.panNumber ? true : false}
                  >
                    <Fieldmik
                      type="text"
                      className="ui input"
                      name="panNumber"
                      placeholder={"PAN Number"}
                    />
                    {touched.panNumber && errors.panNumber ? (
                      <div className="error-msg">
                        {errors.panNumber}
                      </div>
                    ) : null}
                  </FormUi.Field>
                </FormUi.Group>
              </div>
            </div>
          </div>
        </Formiker >
        <center>
          <Button
            type="submit"
            onClick={handleSubmited}
            size="mini"
            className="w3-blue w3-round w3-hover-blue"
          >
            {"Submit"}
          </Button>
        </center>
      </div>
    </React.Fragment >
  )
};

const AddBillingParty = withFormik({
  enableReinitialize: true,
  validationSchema: yup.object({
    creditPeriod: yup.string().optional().nullable().matches(AllRegex.PositiveNumberWithPoint, ERROR_MESSAGES.INVALID_NUMBER),
    billingPartyAddress: yup.string().optional().nullable().matches(AllRegex.Address, ERROR_MESSAGES.INVALID_ADDRESS),
    billingPartyPincodeNo: yup.string().optional().nullable().matches(AllRegex.Pincode, ERROR_MESSAGES.INVALID_PINCODE),
    billingPartyEmail: yup.string().optional().nullable().matches(AllRegex.Email, ERROR_MESSAGES.INVALID_EMAIL),
    billingPartyContactPersonNumber: yup.string().optional().nullable().matches(AllRegex.MobileNumber, ERROR_MESSAGES.INVALID_MOBILE_NO),
    billingPartyName: yup.string().required(ERROR_MESSAGES.FIELD_IS_REQUIRED),
    billingPartyContactPerson: yup.string().required(ERROR_MESSAGES.FIELD_IS_REQUIRED).matches(AllRegex.Name, ERROR_MESSAGES.INVALID_NAME),
    panNumber: yup.string().optional().matches(AllRegex.PANIN, ERROR_MESSAGES.INVALID_PAN_NO).nullable(),
  }),
  mapPropsToValues: (props) => {
    return {
      billingPartyCode: props?.editData?.billingPartyCode || '',
      billingPartyName: props?.editData?.billingPartyName || '',
      billingPartyAddress: props?.editData?.billingPartyAddress || '',
      billingPartyEmail: props?.editData?.billingPartyEmail || '',
      billingPartyContactPersonNumber: props?.editData?.billingPartyContactPersonNumber || '',
      billingPartyContactPerson: props?.editData?.billingPartyContactPerson || '',
      creditPeriod: props?.editData?.creditPeriod || '',
      billingPartyPincodeNo: props?.editData?.billingPartyPincodeNo || '',
      customer_type_id: props?.editData?.customer_type_id || [],
      industrySegmentId: props?.editData?.industrySegmentId || '',
      panNumber: props?.editData?.panNumber || '',
    };
  },
  handleSubmit(values, { setSubmitting, props }) {
    if (props.title === 'Edit Billing Party') {
      if (values.customer_type_id.length > 0) {
        values.customer_type_id.map((element) => {
          values[element] = '1'
        })
      }
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party/${props.editData.billingPartyId}`,
        payload: { ...values },
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.status === 204) {
              cogoToast.error(res.data.message);
            }
            else {
              setSubmitting(false);
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
              });
              cogoToast.success('Billing party Updated').then(() => {
                window.location.href = '/billingparty';
              })
              props.onFormSubmit();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: err.data ? err.data.message : err.message,
          });
        });
      UpdateAxios({
        patchURL: `${process.env.REACT_APP_BASE_URL}/masters/billing_party_type_mapping/test`,
        payload: { ...values, billingPartyId: editData.billingPartyId },
      })
        .then((res) => {
          setSubmitting(false);
          props.successAlertDispatcher({
            type: "success",
            messageHeader: "Success",
            messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
          });
          cogoToast.success('Billing party Updated').then(() => {
            window.location.href = '/billingparty';
          })
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: err.data ? err.data.message : err.message,
          });
        });
    } else {
      if (values.customer_type_id.length > 0) {
        values.customer_type_id.map((element) => {
          values[element] = '1'
        })
      }
      const gett = LOCAL_STORAGE.userToken;
      const apiData = {
        customerNumber: LOCAL_STORAGE.customerNo,
        userId: LOCAL_STORAGE.userId,
        customer_no: +LOCAL_STORAGE.customerNo,
        customerNo: +LOCAL_STORAGE.customerNo,
        user_id: +LOCAL_STORAGE.userId,
        ...values
      };
      Axios.put(`${process.env.REACT_APP_BASE_URL}/masters/billing_party`, apiData, {
        headers: { 'content-type': 'application/json', 'Authorization': `${gett}`, "Access-Control-Allow-Origin": "*" }
      })
        .then((res) => {
          if (res.status === 200) {
            if (res.data.status === 204) {
              cogoToast.error(res.data.message);
            }
            else {
              setSubmitting(false);
              props.successAlertDispatcher({
                type: "success",
                messageHeader: "Success",
                messageBody: typeof res.data.message === 'object' ? res.data.message.message : res.data.message,
              });
              cogoToast.success('Billing party created').then(() => {
                window.location.href = '/billingparty';
              })
              props.onFormSubmit();
            }
          }
        })
        .catch((err) => {
          console.log(err);
          props.successAlertDispatcher({
            type: "error",
            messageHeader: "Error",
            messageBody: err.data ? err.data.message : err.message,
          });
        });
    }
  },
})(InsertBranches);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  (AddBillingParty)
);
